/* One queue shared by product adds and cart changes. Never retry a mutation. */
(() => {
  class GiesenCartQueue {
    constructor() { this.pending = Promise.resolve(); }
    run(operation) {
      const result = this.pending.then(operation);
      this.pending = result.catch(() => {});
      return result;
    }
  }
  globalThis.GiesenCartQueue = GiesenCartQueue;
})();
